/**
 * @Description 地图相关
 */
import { FC, useEffect, useRef, useState } from 'react';
import styles from '../index.module.less';
import V2AMap from '@/common/components/Map/V2AMap';
import { showMarker } from '@/common/utils/map';
import IconFont from '@/common/components/IconFont';
import cs from 'classnames';
import { isDef } from '@lhb/func';
const mapContainer = 'mapContainerAreaProtection';
/**
 * @Description 门店状态定义
 */
export enum ShopStatus {
  Signed = 100, // 已签约
  DeliverApproving = 200, // 交房审批中
  Delivered = 300, // 已交房
  OpenApproving = 400, // 开业审批中
  Openning = 500, // 开业中
  CloseApproving = 600, // 闭店审批中
  CLosed = 700, // 已闭店
}

const Map:FC<any> = ({
  conflictInfo,
  isMKD
}) => {
  const [mapIns, setMapIns] = useState<any>(null);
  const circleRef = useRef<any>(null);// 保护圈实例
  const hoverMarkerRef = useRef<any>(null);// hover的内容

  // 绘制当前机会点的范围和点
  const createCurChancePoint = (conflictInfo) => {
    if (!conflictInfo?.lng || !conflictInfo?.lat) return;
    const circle = new window.AMap.Circle({
      center: new window.AMap.LngLat(conflictInfo.lng, conflictInfo.lat), // 圆心位置
      radius: conflictInfo.distance, // 半径
      strokeColor: '#006AFF', // 设置边框颜色
      fillColor: '#006AFF', // 设置填充颜色
      fillOpacity: 0.1,
      strokeStyle: 'dashed',
      zIndex: 60,
    });
    new window.AMap.Marker({
      map: mapIns,
      icon: new window.AMap.Icon({
        image: 'https://staticres.linhuiba.com/project-custom/locationpc/ic_map_standard_marker@2x.png',
        size: [30, 30],
        imageSize: [30, 30],
        position: [conflictInfo.lng, conflictInfo.lat],
      }),
      anchor: 'bottom-center',
      position: [conflictInfo.lng, conflictInfo.lat],
    });
    mapIns.setFitView(circle);
    mapIns.add(circle);
    circleRef.current = circle;
  };
  // 绘制周边的机会点
  const createSurroundChancePoint = (value) => {
    const circle = new window.AMap.Circle({
      center: [value?.lng, value?.lat], // 圆心位置
      radius: value?.protectRadius, // 半径
      strokeColor: '#F53F3F', // 设置边框颜色
      fillColor: '#F53F3F', // 设置填充颜色
      fillOpacity: 0.1,
      strokeStyle: 'dashed'
    });

    const marker = new window.AMap.Marker({
      anchor: 'bottom-center',
      position: [value?.lng, value?.lat],
    });

    // isMKD时直接不展示冲突的机会点位,但是需要显示圈
    mapIns.add(isMKD ? [circle] : [marker, circle]);
    if (isMKD) return;
    showMarker(marker, <IconFont iconHref='iconic_mendian-jihuidian' className='c-006 fs-24'/>);

    hoverChancePointWithProtect(marker, value);
  };
  // 绘制门店
  const createStore = (value) => {
    const circle = new window.AMap.Circle({
      center: [value?.lng, value?.lat], // 圆心位置
      radius: value?.protectRadius, // 半径
      strokeColor: '#F53F3F', // 设置边框颜色
      fillColor: '#F53F3F', // 设置填充颜色
      fillOpacity: 0.1,
      strokeStyle: 'dashed'
    });

    const marker = new window.AMap.Marker({
      position: [value?.lng, value?.lat],
      anchor: 'bottom-center',
    });

    // isMKD时直接不展示冲突的机会点位,但是需要显示圈
    mapIns.add(isMKD ? [circle] : [marker, circle]);
    if (isMKD) return;
    showMarker(marker, <div className={styles.storeBox}>
      <img className={styles.outerImg} src='https://staticres.linhuiba.com/project-custom/locationpc/map/icon_outer.png'/>
      <img className={styles.innerImg} src={value?.brandLogo ? value?.brandLogo : 'https://staticres.linhuiba.com/project-custom/locationpc/map/icon_store_default.png'}/>
    </div>);
    hoverStore(marker, value);
  };
    // 机会点有区域保护
  const hoverChancePointWithProtect = (marker, value) => {
    // hover展示详情内容
    marker.on('mouseover', () => {
      const dom = document.querySelector(`.${mapContainer}`);
      var pixel = mapIns.lngLatToContainer([value?.lng, value?.lat]);
      const { x, y } = pixel;
      const offset = [0, 0];
      let topBottom = 'top';
      let leftRight = 'center';
      if (y < 190) {
        topBottom = 'top';
      } else if ((dom?.clientHeight || 0) - y < 190) {
        topBottom = 'bottom';
        offset[1] = -29;
      }
      if (x < 190) {
        leftRight = 'left';
      } else if ((dom?.clientWidth || 0) - x < 190) {
        leftRight = 'right';
        offset[0] = -24;
      }
      const hoverMarker = new window.AMap.Marker({
        position: [value?.lng, value?.lat],
        anchor: `${topBottom}-${leftRight}`,
        offset,
        zIndex: 100
      });
      mapIns.add(hoverMarker);


      showMarker(hoverMarker, <div className={styles.storeContent}>
        <div className={styles.name}>{value?.regionName}</div>
        <div className={styles.status}>
          <span className={styles.protect}>区域保护中</span>
        </div>
        {value?.pointStatus ? <div className={styles.card}>
          <span className={styles.label}>机会点状态</span>
          <span className={styles.content}>{value?.pointStatus}</span>
        </div> : <></>}
        {value?.applyUserName ? <div className={styles.card}>
          <span className={styles.label}>保护申请人</span>
          <span className={styles.content}>{value?.applyUserName}</span>
        </div> : <></>}

        {isDef(value?.daysRemaining) ? <div className={styles.card}>
          <span className={styles.label}>保护有效期</span>
          <span className={styles.content}>剩余{value?.daysRemaining}天</span>
        </div> : <></>}

        {value?.protectRadiusStr ? <div className={styles.card}>
          <span className={styles.label}>保护范围</span>
          <span className={styles.content}>{value?.protectRadiusStr}</span>
        </div> : <></>}

      </div>);
      hoverMarkerRef.current = hoverMarker;
    });
    marker.on('mouseout', () => {
      mapIns.remove(hoverMarkerRef.current);
    });
  };
    // 门店
  const hoverStore = (marker, value) => {
    // hover展示详情内容
    marker.on('mouseover', () => {
      const dom = document.querySelector(`.${mapContainer}`);
      var pixel = mapIns.lngLatToContainer([value?.lng, value?.lat]);
      const { x, y } = pixel;
      const offset = [0, 0];
      let topBottom = 'top';
      let leftRight = 'center';
      if (y < 190) {
        topBottom = 'top';
      } else if ((dom?.clientHeight || 0) - y < 190) {
        topBottom = 'bottom';
        offset[1] = -29;
      }
      if (x < 190) {
        leftRight = 'left';
      } else if ((dom?.clientWidth || 0) - x < 190) {
        leftRight = 'right';
        offset[0] = -24;
      }
      const hoverMarker = new window.AMap.Marker({
        position: [value?.lng, value?.lat],
        anchor: `${topBottom}-${leftRight}`,
        offset,
        zIndex: 100
      });
      mapIns.add(hoverMarker);

      const background = value?.status === ShopStatus.Openning ? 'rgba(0,106,255,0.08)'
        : value?.status === ShopStatus.Delivered ? 'rgba(233, 248, 234, 1)'
          : 'rgba(146,165,202,0.07)';

      const color = value?.status === ShopStatus.Openning ? '#006AFF'
        : value?.status === ShopStatus.Delivered ? '#006F07'
          : '#222222';
      const isProtect = [ShopStatus.Signed, ShopStatus.Delivered, ShopStatus.Openning].includes(value?.status);


      showMarker(hoverMarker, <div className={styles.storeContent}>
        <div className={styles.name}>{value?.regionName}</div>
        <div className={styles.status}>
          {isProtect ? <span className={styles.protect}>区域保护中</span> : <></>}
          <span
            className={styles.storeStatus}
            style={{
              background,
              color,
              marginLeft: isProtect ? '4px' : '0'
            }}
          >{value?.shopStatus}</span>
        </div>

        <div className={styles.card}>
          <span className={styles.label}>保护有效期</span>
          <span className={styles.content}>永久保护</span>
        </div>

        {value?.protectRadiusStr ? <div className={styles.card}>
          <span className={styles.label}>保护范围</span>
          <span className={styles.content}>{value?.protectRadiusStr}</span>
        </div> : <></>}

      </div>);
      hoverMarkerRef.current = hoverMarker;
    });
    marker.on('mouseout', () => {
      mapIns.remove(hoverMarkerRef.current);
    });
  };

  useEffect(() => {
    if (!mapIns) return;
    createCurChancePoint(conflictInfo);
  }, [mapIns, conflictInfo]);

  // 冲突门店、机会点
  useEffect(() => {
    if (!mapIns) return;
    const list = conflictInfo?.conflictRegionItemResponseList;
    list?.forEach((item) => {
      // 冲突区域类型 1 门店 2 机会点
      if (item.regionType === 1) {
        createStore(item);
      } else {
        createSurroundChancePoint(item);
      }
    });
  }, [mapIns, conflictInfo, isMKD]);

  return <div className={cs(styles.mapCon, mapContainer)}>
    <V2AMap
      loaded={setMapIns}
    />
    <div
      className={styles.backCoreCon}
      onClick={() => { mapIns?.setFitView(circleRef.current); }}
    >
      <IconFont iconHref='iconic_mendiangengzhong' className='fs-16'/>
    </div>
  </div>;
};
export default Map;
